import React from "react";
import { MdsDeleteRound } from "react-icons-with-materialsymbols/mds";

import { Button } from "@/design/components/button";
import { useAppDispatch } from "@/reduxHooks.ts";
import { ModalTypes, openModal } from "@/slices/modal-slice";

type EdgeToolbarProps = {
  id: string;
  onDelete: () => void;
};

export const CustomEdgeToolbar = ({ id, onDelete }: EdgeToolbarProps) => {
  const dispatch = useAppDispatch();

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(
      openModal({
        modalType: ModalTypes.DELETE_EDGE,
        modalProps: {
          edgeId: id,
          onConfirmDelete: onDelete,
        },
      })
    );
  };

  return (
    <div className="flex gap-0 w-max rounded bg-zinc-700 p-1 pointer-events-auto">
      <Button
        variant={"link"}
        colorScheme="black"
        className="!p-2 rounded !text-white hover:bg-zinc-600"
        onClick={handleDelete}
        title="Delete connection"
      >
        <MdsDeleteRound className="stroke-[22]" size={22} />
      </Button>
    </div>
  );
};

export default CustomEdgeToolbar; 